<template>
	<button class="c_button mid font-semi radius-x-small height-mid gap-mid" @click="onClick">
		<span>{{ props.title }}</span
		><img v-if="!toggleState" src="@/assets/img/common/arrow_down.svg" alt="더보기 아이콘" loading="lazy" />
		<img
			v-if="toggleState && pageWithToggleButton.includes(props.title)"
			src="@/assets/img/common/arrow_up.svg"
			alt="더보기 아이콘"
		/>
	</button>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const pageWithToggleButton = ['지표별 설명 보기'];
const toggleState = ref(false);

const props = withDefaults(
	defineProps<{
		title?: string;
	}>(),
	{
		title: '더보기',
	}
);
const emit = defineEmits(['click']);

const onClick = () => {
	if (pageWithToggleButton.includes(props.title)) {
		toggleState.value = !toggleState.value;
	}
	emit('click');
};
</script>

<style lang="scss" scoped>
.c_button {
	width: 100%;
}
</style>
